/* eslint-disable no-unused-vars */

export enum CustomerFeatureStatus {
  Active = 1,
  Deactivated = 2,
  Requested = 3,
}
